import { Button, Space } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { logout, logoutAllUsers } from '../methods/auth';

const LogoutStyle = styled.section`
	padding-top: 10px;
	padding-bottom: 10px;
`;

const Logout = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [loadingAll, setLoadingAll] = useState(false);

	const logoutAction = async () => {
		setLoading(true);
		await logout(navigate);
		setLoading(false);
	};

	const logoutAllAction = async () => {
		setLoadingAll(true);
		await logoutAllUsers(navigate);
		setLoadingAll(false);
	};

	return (
		<LogoutStyle>
			<Space>
				<Button danger loading={loading} onClick={logoutAction}>
					Logout
				</Button>
				<Button danger loading={loadingAll} onClick={logoutAllAction}>
					Logout All Devices
				</Button>
			</Space>
		</LogoutStyle>
	);
};

export default Logout;
